import React, { useState } from "react";
import "../ui/tokens.css";
import "./guest.css";

export const NUDGE_AT_SECONDS = 60;

// One quiet card when about a minute of the demo is left. Shown once; dismissing it keeps it away.
export default function GuestNudge({ secondsLeft, onCreateAccount }) {
  const [dismissed, setDismissed] = useState(false);
  const visible = !dismissed && secondsLeft !== null && secondsLeft !== undefined && secondsLeft > 0 && secondsLeft <= NUDGE_AT_SECONDS;
  if (!visible) return null;
  return (
    <div className="gn" role="status">
      <p className="gn-text">
        <b>About a minute left.</b> Create a free account to keep talking and save your chats.
      </p>
      <div className="gn-actions">
        <button type="button" className="gn-primary" onClick={onCreateAccount}>
          Create account
        </button>
        <button type="button" className="gn-dismiss" onClick={() => setDismissed(true)}>
          Not now
        </button>
      </div>
    </div>
  );
}
